
























































































import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class AlertBox extends Vue {
  @Prop({ required: true }) readonly type!: string;
  @Prop({ default: "" }) readonly id!: string;
  @Prop({ default: false }) readonly closeable!: boolean;
  @Prop({ default: true }) readonly showIcon!: boolean;
  @Prop({ default: false }) readonly padding!: boolean;
}
